"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBarPoint = exports.ProgressBar = exports.ProgressBarWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_tippy_1 = require("react-tippy");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var ProgressBarWrapper = function (props) {
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "progress-bar-wrapper ".concat(props.className || "") }, { children: props.children })));
};
exports.ProgressBarWrapper = ProgressBarWrapper;
var ProgressBar = function (props) {
    var styles = {
        width: props.width < 0 ? "0%" : props.width > 100 ? "100%" : props.width + "%",
        left: props.offset < 0 ? "0%" : props.offset > 100 ? "100%" : props.offset + "%"
    };
    var cls = (0, BootstrapHelper_1.B)()
        .bl("progress-bar")
        .pmod(props.type || "primary").bem;
    return (0, jsx_runtime_1.jsx)("div", { className: cls, style: styles });
};
exports.ProgressBar = ProgressBar;
var ProgressBarPoint = function (props) {
    var styles = {
        left: props.offset < 0 ? "0%" : props.offset > 100 ? "100%" : props.offset + "%"
    };
    var cls = (0, BootstrapHelper_1.B)()
        .bl("progress-bar__point")
        .pmod(props.type || "primary")
        .pmod(props.shape || "line").bem;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(cls, " ").concat(props.className || ""), style: styles }, { children: (0, jsx_runtime_1.jsx)(react_tippy_1.Tooltip, __assign({ theme: "light", html: props.tooltipContent }, { children: (0, jsx_runtime_1.jsx)("div", { className: "progress-bar__point-placeholder" }) })) })));
};
exports.ProgressBarPoint = ProgressBarPoint;
